import axios from "axios";
import { validTokenExists } from "../firebaseHelper";


export const eventPreviewView = async (previewId, seconds, options = {}) => {
    try {
        await validTokenExists();
    } catch (_) {
        return false;
    }
    // Retry the captured payload, never read the current audio source here.
    // The server merges progress and deduplicates the session contribution.
    const payload = { previewId, seconds, ...options };
    for (let attempt = 0; attempt < 3; attempt += 1) {
        try {
            const res = await axios.post('/preview_view', payload);
            if (res.data.error) throw new Error(res.data.error);
            return true;
        } catch (error) {
            const status = error.response?.status;
            if ((status >= 400 && status < 500 && status !== 429) || attempt === 2) {
                console.log(error.response?.data?.error || error.message);
                return false;
            }
            await new Promise(resolve => setTimeout(resolve, (attempt + 1) * 500));
        }
    }
    return false;
};


export const eventLog = (type, details) => {
    validTokenExists()
        .then(() => {
            axios
                .post('/log', {
                    type: type,
                    details: details,
                })
                .then((res) => {
                    if (res.data.error) {
                        // TODO display error message to user...
                        console.log(res.data.error);
                    }
                })
                .catch((err) => {
                    // TODO display error message to user...
                    console.log(err.response.data.error);
                });
        })
        .catch((e) => {
            // Not logged in.
        });
};


export const report = (type, details) => {
    validTokenExists()
        .then(() => {
            axios
                .post('/report', {
                    type: type,
                    details: details,
                })
                .then((res) => {
                    if (res.data.error) {
                        // TODO display error message to user...
                        console.log(res.data.error);
                    }
                })
                .catch((err) => {
                    // TODO display error message to user...
                    console.log(err.response.data.error);
                });
        })
        .catch((e) => {
            // Not logged in.
        });
};


export const eventPreviewShared = (previewId) => {
    validTokenExists()
        .then(() => {
            axios
                .post('/preview_shared', {
                    previewId: previewId,
                })
                .then((res) => {
                    if (res.data.error) {
                        // TODO display error message to user...
                        console.log(res.data.error);
                    }
                })
                .catch((err) => {
                    // TODO display error message to user...
                    console.log(err.response.data.error);
                });
        })
        .catch((e) => {
            // Not logged in.
        });
};
